import { put, call, select } from 'redux-saga/effects'
import { BFFAgent } from '../../../../common/BFFAgent'
import {
    PRICE_POLICIES_GET_ROLE_BONIFICATION_SUCCESS,
    PRICE_POLICIES_GET_ROLE_BONIFICATION_FAILURE
} from '../constants'
import { groupBy } from 'lodash'

export function* getRoleBonificationsSaga({data: { valueTabSelected }}) {
    const carLots = yield select(
        state => state.common?.user?.license?.company.Car_lots
    )
    const userRoles = yield select(state => state.pricePolicies?.userRoles)

    try {
        const responseRolesBonifications = yield call(BFFAgent.PricePolicy.getRolesBonifications, valueTabSelected.toUpperCase())
        responseRolesBonifications.map(bonification => {
          const {name: companyName} = carLots.find(carLot => carLot.id === bonification.car_lot_id);
          bonification.car_lot_name = companyName;
        })
        const groupByCarlot = groupBy(responseRolesBonifications, "car_lot_id")
        
        const roleBonification = {}

        for(let bonificationRule of Object.values(groupByCarlot)) {
            for(let index = 0; index < bonificationRule.length; index++) {
                const item = bonificationRule[index]
                
                const role = userRoles.find(element => element.value === item.role_id)

                let role_id_disabled = []
                const name = item.car_lot_name

                if(Number(index) >= 1) {
                    if(bonificationRule.length === (Number(index) + 1)) {
                        role_id_disabled = roleBonification[name].data[index - 1].role_id_disabled.length
                        ? [
                            ...roleBonification[name].data[
                                index - 1
                            ].role_id_disabled
                        ]
                        : [roleBonification[name].data[0].role_id]
                    } else {
                        if(Number(index) === 1) {
                            role_id_disabled = [roleBonification[name].data[0].role_id, role?.value]
                        } else if(Number(index) > 1) {
                            role_id_disabled = [...roleBonification[name].data[index - 1].role_id_disabled, role?.value]
                        }
                    }
                }

                if(!roleBonification[name]) {
                    roleBonification[name] = {
                        name,
                        data: []
                    }
                }
                 
                 roleBonification[name].data = [...roleBonification[name].data, {
                    car_lot_id: item.car_lot_id,
                    car_lot_name: name,
                    value: item.value !== 0 ? item.value.toString().replace(".",",") : "", 
                    sale_type: valueTabSelected.toUpperCase(),
                    role_id: item.role_id,
                    role_id_disabled,
                    rolName: role?.label,
                    id: item.id
                }]
            }
        }

        for (const carLot of carLots) {
            if(!roleBonification[carLot.name]) {
                roleBonification[carLot.name] = {
                    name: carLot.name,
                    data: [
                        {
                            car_lot_id: carLot.id,
                            car_lot_name: carLot.name,
                            value: '',
                            sale_type: valueTabSelected.toUpperCase(),
                            role_id: '',
                            role_id_disabled: []
                        }
                    ]
                }
            }
        }
        
        yield put({
            type: PRICE_POLICIES_GET_ROLE_BONIFICATION_SUCCESS,
            data: { roleBonification }
        })
    } catch (error) {
        yield put({
            type: PRICE_POLICIES_GET_ROLE_BONIFICATION_FAILURE,
            data: { userRolesError: error }
        })
    }
}
